module.exports = __webpack_public_path__ + "img/okr-company.f86df16e.png";